import { render } from "./ReminderTabs.vue?vue&type=template&id=4184bffa&scoped=true&ts=true"
import script from "./ReminderTabs.vue?vue&type=script&lang=ts"
export * from "./ReminderTabs.vue?vue&type=script&lang=ts"

import "./ReminderTabs.vue?vue&type=style&index=0&id=4184bffa&scoped=true&lang=css"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4184bffa"]])

export default __exports__